import {twMerge} from '../../../../common/twMerge';
import {Text} from '../../../atoms/Text/Text';

export function NewsWithLine({children}: {children: React.ReactNode}) {
  return (
    <div
      className={twMerge(
        'w-full',
        'flex flex-col',
        'rounded-b-12pxr',
        'space-y-18pxr p-18pxr'
      )}
    >
      <div className="h-1pxr bg-theme-transparent-20" />
      <Text className="font-small1 whitespace-pre-wrap text-theme-solid-100 break-word-anywhere">
        {children}
      </Text>
    </div>
  );
}
